import { useState, useEffect, useCallback } from "react";
import {
  getPublicLogements,
  getCoupsDeCoeur,
  getPublicTémoignages,
  getPublicFaq,
} from "@/lib/api";
import { BANNER_IMAGES } from "@/data/homeData";
import { HeroCarousel } from "@/components/home/HeroCarousel";
import { SearchBar } from "@/components/home/SearchBar";
import { PropertiesGrid } from "@/components/home/PropertiesGrid";
import { ParallaxBanner } from "@/components/home/ParallaxBanner";
import { DiscoveryCTA } from "@/components/home/DiscoveryCTA";
import { BentoServicesGrid } from "@/components/home/BentoServicesGrid";
import { WhyChooseUs } from "@/components/home/WhyChooseUs";
import { AnimatedStats } from "@/components/home/AnimatedStats";
import { TestimonialsSection } from "@/components/home/TestimonialsSection";
import { EstimateurSection } from "@/components/home/EstimateurSection";
import { OffresTeaser } from "@/components/home/OffresTeaser";
import { FaqSection } from "@/components/home/FaqSection";
import { FinalCTA } from "@/components/home/FinalCTA";

export default function HomePage() {
  const [allLogements, setAllLogements] = useState([]);
  const [témoignages, setTémoignages] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [searchFilters, setSearchFilters] = useState({
    ville: "",
    type_logement: "",
    capacite_min: "",
  });

  const loadData = useCallback(async () => {
    try {
      const [logementsRes, témoignagesRes, faqRes] = await Promise.all([
        getPublicLogements(),
        getPublicTémoignages("proprietaire"),
        getPublicFaq(),
      ]);
      setAllLogements(logementsRes.data);
      setTémoignages(témoignagesRes.data);
      setFaqs(faqRes.data);
    } catch (error) {
      console.error("Error loading data:", error);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const filteredLogements = allLogements.filter((l) => {
    if (searchFilters.ville && !l.ville.toLowerCase().includes(searchFilters.ville.toLowerCase())) return false;
    if (searchFilters.type_logement && l.type_logement !== searchFilters.type_logement) return false;
    if (searchFilters.capacite_min && l.capacite < parseInt(searchFilters.capacite_min)) return false;
    return true;
  });

  return (
    <div className="overflow-hidden bg-[#F5F0EB]">
      <HeroCarousel />
      <SearchBar searchFilters={searchFilters} setSearchFilters={setSearchFilters} />
      <PropertiesGrid logements={filteredLogements} searchFilters={searchFilters} setSearchFilters={setSearchFilters} />
      <ParallaxBanner src={BANNER_IMAGES.cozyLiving} alt="Intérieur chaleureux" />
      <DiscoveryCTA />
      <BentoServicesGrid />
      <ParallaxBanner src={BANNER_IMAGES.stoneFireplace} alt="Salon avec cheminée" />
      <WhyChooseUs />
      <AnimatedStats />
      <TestimonialsSection témoignages={témoignages} />
      <EstimateurSection />
      <OffresTeaser />
      <FaqSection faqs={faqs} />
      <ParallaxBanner src={BANNER_IMAGES.frenchVillage} alt="Village français" />
      <FinalCTA />
    </div>
  );
}
